import axios from "axios";
import qs from "qs" ;
import dataProvider from "../../../services/dataProvider";

// let testData = {
//     key1: "<!DOCTYPE html>\n<html>\n<body>\n\n<a href=https://www.w3schools.com>This is a link</a>\n\n</body>\n</html>\n",
//     key2: '<!DOCTYPE html>\n<html>\n<body>\n\n<h2>Width and Height Attributes</h2>\n\n<p>The width and height attributes of the img tag, defines the width and height of the image:</p>\n\n<img src="img_girl.jpg" width="500" height="600">\n\n</body>\n</html>\n\n',
// };

function getPdfs(htmlList,names) {
    return new Promise((res, rej) => {
        var data = qs.stringify(htmlList);
        var config = {
            method: "post",
            url: dataProvider.baseUrl + "generateMultiplePdfs",
            // url: "http://localhost:5001/icomply-dev/us-central1/generateMultiplePdfs",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                res(response);
            })
            .catch(function (error) {
                rej(error);
            });
    });
}

export default function PDFZipDownload(htmlList,names) {
    return new Promise((resolve) => {
        getPdfs(htmlList,names).then((res) => {
            let zip = require("jszip")();
    
            Object.keys(res.data || {}).forEach((key,i) => {
                zip.file(names[i]+".pdf", res.data[key].data);
            })
    
            zip.generateAsync({ type: "blob" }).then(function (content) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                // console.log(content);
                let url = window.URL.createObjectURL(content);
                a.href = url;
                a.download = "forms.zip";
                a.click();
                window.URL.revokeObjectURL(url);
                resolve();
            });
    
        });
    })
    
}